module.exports = __webpack_public_path__ + "img/CM.115545c1.png";